import { render, staticRenderFns } from "./CourseCreate.vue?vue&type=template&id=4a2bc0a0"
import script from "../../controllers/course/course-create.js?vue&type=script&lang=js&external"
export * from "../../controllers/course/course-create.js?vue&type=script&lang=js&external"
import style0 from "./CourseCreate.vue?vue&type=style&index=0&id=4a2bc0a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports